// extracted by mini-css-extract-plugin
export default {"pageLayout":"N-z","mainContent":"O-z","columnLayout":"P-z","columnLayoutFill":"Q-z","columnLayoutLast":"R-z"};